// extracted by mini-css-extract-plugin
export default {"form":"CaseForm_form__f4+0E","actionButtons":"CaseForm_actionButtons__zlTfO","container":"CaseForm_container__LfXGp","teeth":"CaseForm_teeth__E2VlC"};